module.exports = __webpack_public_path__ + "img/foto_2.e9ca37a2.png";